import React, { useEffect, useState } from "react";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import api from "@/lib/api";
import AdminPhonebook from "@/pages/admin/Phonebook";
import Ledger from "@/pages/shared/Ledger";

export default function Resources() {
  const [tab, setTab] = useState("phonebook");
  const [flags, setFlags] = useState({ ledger: false, phonebook: true });

  useEffect(() => {
    api.get("/feature-flags").then(({ data }) => {
      setFlags(data);
      if (data.phonebook === false && data.ledger) setTab("ledger");
    }).catch(() => {});
  }, []);

  const phonebookOn = flags.phonebook !== false;

  return (
    <div>
      <Tabs value={tab} onValueChange={setTab}>
        <TabsList className="mb-4" data-testid="resources-tabs">
          {phonebookOn && <TabsTrigger value="phonebook" data-testid="resources-tab-phonebook">Phonebook</TabsTrigger>}
          {flags.ledger && <TabsTrigger value="ledger" data-testid="resources-tab-ledger">Rally Books</TabsTrigger>}
        </TabsList>
        {phonebookOn && <TabsContent value="phonebook" data-testid="resources-panel-phonebook"><AdminPhonebook /></TabsContent>}
        {flags.ledger && <TabsContent value="ledger" data-testid="resources-panel-ledger"><Ledger /></TabsContent>}
      </Tabs>
      {!phonebookOn && !flags.ledger && (
        <div className="py-16 text-center text-sm text-slate-400" data-testid="resources-all-off">No resources are currently enabled.</div>
      )}
    </div>
  );
}
